import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import LogoHeader from '../Assets/Images/aim logo png.png';
import '../Assets/Css/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";


function WebHeader() {
    const location = useLocation();
    const [expanded, setExpanded] = useState(false); // Add state

    const handleNavClick = () => {
        setExpanded(false); // Collapse navbar on link click
    };

    // const [showDropdown, setShowDropdown] = useState(false);

    const blogPaths = ["/blog", "/blog1", "/blog2", "/blog3", "/blog4", "/blog5"];

    return (
        <>
            {/* Top Contact Navbar */}
            <div className="top-header"
                style={{
                    backgroundColor: '#255595',
                    color: 'white',
                    padding: '8px 0',
                    fontSize: '14px',
                    textAlign: 'center',
                    width: '100%',
                    position: 'fixed',
                    top: 0,
                    zIndex: 1060,
                    transition: 'all 0.3s ease-in-out'
                }}>

                <Container className="d-flex justify-content-between align-items-center">
                    <div className="contact-info">
                        <a
                            href="mailto:info@aimindproducts.com"
                            style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                        >
                            <MdMarkEmailRead />
                            <span>info@aimindproducts.com</span>
                        </a>

                        <span className='mx-1'>|</span>

                        <a
                            href="https://wa.me/9822980560 "
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <span><FaPhoneSquareAlt />9822980560 </span>
                        </a>

                        <span className='mx-1'>|</span>

                        <a
                            href="https://wa.me/9822980225 "
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <span><FaPhoneSquareAlt />9822980225    </span>
                        </a>
                    </div>

                    <div>
                        <a href="https://www.facebook.com/share/1FG6dqFDEw/">
                            <FaFacebook color='white' size={15} />
                        </a>
                        <a className=' mx-2' href='https://www.youtube.com/@AimIndustrialProducts'>
                            <IoLogoYoutube color='white' size={15} />
                        </a>
                    </div>
                </Container>
            </div>

            {/* Main Navbar */}
            <Navbar expand="lg" className="custom-navbar fixed-top" expanded={expanded}>
                <Container>
                    <Navbar.Brand as={NavLink} to="/">
                        <img src={LogoHeader} alt="Logo"
                            className="navbar-logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mx-auto">
                            <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>About Us</Nav.Link>
                            <Nav.Link as={NavLink} to="/products" onClick={handleNavClick}>Products</Nav.Link>

                            {/* <Nav.Link as={NavLink} to="/blog"  onClick={handleNavClick}>Blogs</Nav.Link> */}

                            <Nav.Link
                                as={NavLink}
                                to="/blog"
                                className={blogPaths.includes(location.pathname) ? "active" : ""}
                                onClick={handleNavClick}
                            >
                                Blogs
                            </Nav.Link>
                            {/* <Nav.Link as={NavLink} to="/faqs"  onClick={handleNavClick}>FAQs  </Nav.Link> */}
                            <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick}>Contact Us </Nav.Link>
                        </Nav>
                        <div >
                            <a
                                href="https://wa.me/9822980560 "
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <Button size="lg" className=" reqbtn  fw-bold shadow">
                                    Request a Quote
                                </Button>
                            </a>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default WebHeader;

















// import { useEffect, useState } from 'react';
// import { NavLink, useLocation } from 'react-router-dom';
// import { Container, Button } from 'react-bootstrap';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';

// import LogoHeader from '../Assets/Images/aim logo png.png';
// import '../Assets/Css/webheader.css';
// import { MdMarkEmailRead } from "react-icons/md";
// import { FaPhoneSquareAlt } from "react-icons/fa";

// import { FaFacebook } from "react-icons/fa";
// import { IoLogoYoutube } from "react-icons/io";


// function WebHeader() {
//     const location = useLocation();
//     const [expanded, setExpanded] = useState(false); // Add state

//     const handleNavClick = () => {
//         setExpanded(false); // Collapse navbar on link click
//     };

//     const blogPaths = ["/blog", "/blog1", "/blog2", "/blog3", "/blog4", "/blog5"];


//     // App Install Button

//     const [deferredPrompt, setDeferredPrompt] = useState(null);
//     const [showInstallButton, setShowInstallButton] = useState(false);

//     useEffect(() => {
//         const handler = (e) => {
//             e.preventDefault();
//             setDeferredPrompt(e);
//             setShowInstallButton(true);
//         };

//         window.addEventListener('beforeinstallprompt', handler);

//         return () => {
//             window.removeEventListener('beforeinstallprompt', handler);
//         };
//     }, []);

//     const handleInstallClick = async () => {
//         if (deferredPrompt) {
//             deferredPrompt.prompt();
//             const { outcome } = await deferredPrompt.userChoice;
//             if (outcome === 'accepted') {
//                 console.log('User accepted the install prompt');
//             } else {
//                 console.log('User dismissed the install prompt');
//             }
//             setDeferredPrompt(null);
//             setShowInstallButton(false);
//         }
//     };


//     return (
//         <>
//             {/* Top Contact Navbar */}
//             <div className="top-header"
//                 style={{
//                     backgroundColor: '#255595',
//                     color: 'white',
//                     padding: '8px 0',
//                     fontSize: '14px',
//                     textAlign: 'center',
//                     width: '100%',
//                     position: 'fixed',
//                     top: 0,
//                     zIndex: 1060,
//                     transition: 'all 0.3s ease-in-out'
//                 }}>
//                 <Container className="d-flex justify-content-between align-items-center">
//                     <div className="contact-info">
//                         <a
//                             href="mailto:info@aimindproducts.com"
//                             style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
//                         >
//                             <MdMarkEmailRead />
//                             <span>info@aimindproducts.com</span>
//                         </a>

//                         <span className='mx-1'>|</span>

//                         <a
//                             href="https://wa.me/9822980560 "
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ textDecoration: 'none', color: 'inherit' }}
//                         >
//                             <span><FaPhoneSquareAlt />9822980560 </span>
//                         </a>

//                         <span className='mx-1'>|</span>

//                         {/* <a
//                             href="https://wa.me/9822980225 "
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ textDecoration: 'none', color: 'inherit' }}
//                         >
//                             <span><FaPhoneSquareAlt />9822980225    </span>
//                         </a> */}
//                     </div>

//                     <div>
//                         {showInstallButton && (
//                             <button
//                                 onClick={handleInstallClick}
//                                 style={{
//                                     marginLeft: '10px',
//                                     padding: '4px 10px',
//                                     backgroundColor: '#ff6600',
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '4px',
//                                     cursor: 'pointer',
//                                     fontSize: '13px',
//                                     fontWeight: '500',
//                                 }}
//                             >
//                                 Install App
//                             </button>
//                         )}
//                         {/* <a href="https://www.facebook.com/share/1FG6dqFDEw/">
//                             <FaFacebook color='white' size={15} />
//                         </a>
//                         <a className=' mx-2' href='https://www.youtube.com/@AimIndustrialProducts'>
//                             <IoLogoYoutube color='white' size={15} />
//                         </a> */}
//                     </div>
//                 </Container>
//             </div>

//             {/* Main Navbar */}
//             <Navbar expand="lg" className="custom-navbar fixed-top" expanded={expanded}>
//                 <Container>
//                     <Navbar.Brand as={NavLink} to="/">
//                         <img src={LogoHeader} alt="Logo"
//                             className="navbar-logo" />
//                     </Navbar.Brand>

//                     <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />

//                     <Navbar.Collapse id="basic-navbar-nav">
//                         <Nav className="mx-auto">
//                             <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>Home</Nav.Link>
//                             <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>About Us</Nav.Link>
//                             <Nav.Link as={NavLink} to="/products" onClick={handleNavClick}>Products</Nav.Link>

//                             {/* <Nav.Link as={NavLink} to="/blog"  onClick={handleNavClick}>Blogs</Nav.Link> */}

//                             <Nav.Link
//                                 as={NavLink}
//                                 to="/blog"
//                                 className={blogPaths.includes(location.pathname) ? "active" : ""}
//                                 onClick={handleNavClick}
//                             >
//                                 Blogs
//                             </Nav.Link>
//                             {/* <Nav.Link as={NavLink} to="/faqs" onClick={handleNavClick}>FAQs  </Nav.Link> */}

//                             <Nav.Link as={NavLink} to="/contact" onClick={handleNavClick}>Contact Us </Nav.Link>

//                         </Nav>
//                         <div >
//                             <a
//                                 href="https://wa.me/9822980560 "
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 style={{ textDecoration: 'none', color: 'inherit' }}
//                             >
//                                 <Button size="lg" className=" reqbtn  fw-bold shadow">
//                                     Request a Quote
//                                 </Button>
//                             </a>
//                         </div>
//                     </Navbar.Collapse>

//                 </Container>
//             </Navbar>

//         </>
//     );
// }

// export default WebHeader;